import { render, staticRenderFns } from "./ShareACopy.vue?vue&type=template&id=539f3688&scoped=true&"
import script from "./ShareACopy.vue?vue&type=script&lang=js&"
export * from "./ShareACopy.vue?vue&type=script&lang=js&"
import style0 from "./ShareACopy.vue?vue&type=style&index=0&id=539f3688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539f3688",
  null
  
)

export default component.exports